import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { prefixUrl } from '../../utils/url.util';

export type EventqAiEventTagVariant = 'motion' | 'human' | 'vehicle' | 'gun';

const TAG_ICONS: Record<EventqAiEventTagVariant, string> = {
  motion: '/assets/events/icons/tag-motion.svg',
  human: '/assets/events/icons/tag-human.svg',
  vehicle: '/assets/events/icons/tag-vehicle.svg',
  gun: '/assets/events/icons/tag-gun.svg',
};

@Component({
  selector: 'eventq-ai-event-tag',
  templateUrl: './ai-event-tag.html',
  styleUrl: './ai-event-tag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAiEventTag {
  readonly label = input.required<string>();
  readonly variant = input<EventqAiEventTagVariant>('motion');

  readonly iconSrc = computed(() => prefixUrl(TAG_ICONS[this.variant()]));
}
